







































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyList from "@/mixins/list";

import Add from "./price_add.vue";
import Edit from "./price_edit.vue";
import { number } from "echarts/core";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: any[];

  @Prop({ default: true }) isAdd!: boolean;

  @Prop({ default: true }) canEdit!: boolean;

  priceSettings: any[] = [];

  addData: any = {};

  weeks1: string[] = [];
  weeksArr: string[] = [];
  minObj: any = {};

  maxObj: any = {};

  businessTime: any = {
    is_ai_online: false,
    order: {
      src: [],
      dest: []
    },
    ai: {
      src: [],
      dest: []
    }
  };

  allowHalfAnHour = false;

  allowChargeByNumber = false;

  mounted() {
    this.loadBusinessTime();
    this.loadStadiumSettings();
    this.loadPriceSettings();

    for (const obj of this.weeks) {
      this.weeks1.push(obj.key);
      this.weeksArr.push(obj.key);
      // console.log(obj,77777)
    }
  }
  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            console.log(fieldValues,'fieldValues')
          },
        });
      }
    });
  }
  async loadBusinessTime() {
    const res = await this.$store.dispatch("stadium/businessTime", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data) {
      // console.log(res.Data);
      this.businessTime = res.Data;
    }
  }

  async loadStadiumSettings() {
    const res = await this.$store.dispatch("stadium/settingDetail", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data) {
      this.allowHalfAnHour = res.Data.is_half_time === "1";
    }
  }

  async loadPriceSettings() {
    // 价格设置
    const res3 = await this.$store.dispatch("stadium/getStadiumPriceSetting", {
      stadium_id: this.stadiumId
    });

    if (res3 && res3.Data) {
      for (const obj of res3.Data) {
        obj.status = 1;
        obj.price /= 100;
        obj.premium_price /=100;
      }
      this.priceSettings = res3.Data.sort((a: any, b: any) => b.price_sn - a.price_sn);

      for (const obj of this.priceSettings) {
        if (obj.price_type == "1") {
          this.allowChargeByNumber = true;
        }
        const key = `${obj.week_from}-${obj.week_to}-${obj.ground_id_from}-${obj.ground_id_to}`;

        if (Number(obj.hour_from) < Number(_.get(this.minObj, [key], "0"))) {
          _.set(this.minObj, [key], obj.hour_from);
        } else {
          _.set(this.minObj, [key], obj.hour_from);
        }
        if (Number(obj.hour_to) > Number(_.get(this.maxObj, [key], "0"))) {
          _.set(this.maxObj, [key], obj.hour_to);
        } else {
          _.set(this.maxObj, [key], obj.hour_to);
        }
      }

      // console.log(this.minObj);
      // console.log(this.maxObj);
    }
  }

  changeSettingStatus(fieldname: string, fieldval: string, content: string) {
    this.showTsConfirm({
      title: "确认信息",
      content: "确认要操作？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/settingChange", {
          stadium_id: this.stadiumId,
          fieldname,
          fieldval,
          content
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadStadiumSettings();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  getPriceItem(type:number,week: number, hour: number, minute: number, groundId: number) {
    const data = this.priceSettings;

    const tempPrice = 0;

    for (const obj of data) {
      // 增加判断不营业的
      if (
        week >= obj.week_from &&
        week <= obj.week_to &&
        groundId >= obj.ground_id_from &&
        groundId <= obj.ground_id_to &&
        obj.price_type == type
      ) {
        const key = `${obj.week_from}-${obj.week_to}-${obj.ground_id_from}-${obj.ground_id_to}`;
        const wtime=hour*60+minute;
        const stime=obj.hour_from*60+obj.min_from;
        const etime=obj.hour_to*60+obj.min_to;
        if(stime<=wtime && wtime<etime){
          return obj;
        }
        // if (hour >= obj.hour_from && hour < obj.hour_to) {
        //   // 检查后边的配置项，取最后一个
        //   if (minute == 0) {
        //     if (hour == obj.hour_from) {
        //       if (obj.min_from == 0) {
        //         return obj;
        //       }
        //     } else {
        //       return obj;
        //     }
        //   } else {
        //     // if (obj.min_from == 30) {
        //     return obj;
        //     // }
        //   }
        // } else if (hour == obj.hour_to) {
        //   if (obj.min_to == 30) {
        //     if (minute == 0) {
        //       return obj;
        //     }
        //   }
        // }
      } else {
        continue;
      }
    }

    return null;
  }

  getHourPrice(week: number, hour: number, minute: number, groundId: number) {
    const data = this.priceSettings;

    const tempPrice = 0;

    // console.log(maxObj)
    // console.log(minObj)

    for (const obj of data) {
      // 增加判断不营业的
      if (
        week >= obj.week_from &&
        week <= obj.week_to &&
        groundId >= obj.ground_id_from &&
        groundId <= obj.ground_id_to &&
        obj.price_type == "0"
      ) {
        const key = `${obj.week_from}-${obj.week_to}-${obj.ground_id_from}-${obj.ground_id_to}`;
        if (hour >= obj.hour_from && hour < obj.hour_to) {
          // 检查后边的配置项，取最后一个
          if (minute == 0) {
            if (hour == obj.hour_from) {
              if (obj.min_from == 0) {
                return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
              }
            } else {
              return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
            }
          } else {
            // if (obj.min_from == 30) {
            return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
            // }
          }
        } else if (hour == obj.hour_to) {
          if (obj.min_to == 30) {
            if (minute == 0) {
              return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
            }
          }
        }
      } else {
        continue;
      }
    }

    // return `${tempPrice}`
  }

  getNumberPrice(week: number, hour: number, minute: number, groundId: number) {
    const data = this.priceSettings;

    const tempPrice = 0;

    // console.log(maxObj)
    // console.log(minObj)

    for (const obj of data) {
      // 增加判断不营业的
      if (
        week >= obj.week_from &&
        week <= obj.week_to &&
        groundId >= obj.ground_id_from &&
        groundId <= obj.ground_id_to &&
        obj.price_type == "1"
      ) {
        const key = `${obj.week_from}-${obj.week_to}-${obj.ground_id_from}-${obj.ground_id_to}`;
        if (hour >= obj.hour_from && hour < obj.hour_to) {
          // 检查后边的配置项，取最后一个
          if (minute == 0) {
            if (hour == obj.hour_from) {
              if (obj.min_from == 0) {
                return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
              }
            } else {
              return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
            }
          } else {
            // if (obj.min_from == 30) {
            return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
            // }
          }
        } else if (hour == obj.hour_to) {
          if (obj.min_to == 30) {
            if (minute == 0) {
              return `${obj.price}${obj.premium_price>0?(' (+'+obj.premium_price+')'):''}`;
            }
          }
        }
      } else {
        continue;
      }
    }

    // return `${tempPrice}`
  }

  getPrice1(week: number, hour: number, minute: number, groundId: number) {
    const hourItem = this.getPriceItem(0,week,hour,minute,groundId);
    const numberItem = this.getPriceItem(1,week,hour,minute,groundId);
    const hourPrice = hourItem?hourItem.price:0;// this.getHourPrice(week, hour, minute, groundId);
    const numberPrice =numberItem?numberItem.price:0;// this.getNumberPrice(week, hour, minute, groundId);
    console.log('xx',hourItem,hourPrice,numberItem,numberPrice)
    if (hourPrice || numberPrice) {
      const c= `${hourPrice ? `<span style="background-color:#87d068;">${hourPrice}${hourItem.premium_price>0?(' (+'+hourItem.premium_price+')'):''}</span>` : "-"}<br/>/${
        numberPrice ? `<span style="background-color:#f50;">${numberPrice}${numberItem.premium_price>0?(' (+'+numberItem.premium_price+')'):''}</span>` : "-"
      }`;
      console.log('ui',c);
      return c
    }
    return "未营业";
  }

  isNewTime(week: number, hour: number, minute: number, groundId: number) {
    const data = this.priceSettings;
    for (const obj of data) {
      // 增加判断不营业的
      if (
        week >= obj.week_from &&
        week <= obj.week_to &&
        groundId >= obj.ground_id_from &&
        groundId <= obj.ground_id_to
      ) {
        const key = `${obj.week_from}-${obj.week_to}-${obj.ground_id_from}-${obj.ground_id_to}`;
        const wtime=hour*60+minute;
        const stime=obj.hour_from*60+obj.min_from;
        const etime=obj.hour_to*60+obj.min_to;
        if(stime<=wtime && wtime<etime){
          return obj.type>1
        }
      } else {
        continue;
      }
    }
    return false
  }

  resetPrice() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要删除旧的配置，重新配置价格吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/resetStadiumPrice", {
          stadium_id: this.stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("清除旧的配置成功，请重新配置价格");
          this.loadPriceSettings();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  showAddModal2(params: any) {
    this.addData = {};
    this.addModalVisible = true;
  }

  showAddModal1(params: any) {
    this.addData = params;
    this.addModalVisible = true;
  }

  hideAddModal1() {
    this.addModalVisible = false;
    this.addData = {};
    this.loadPriceSettings();
  }

  showEditModal1(params: any) {
    // console.log(params);
    if (this.canEdit) {
      this.addData = params;
      this.editModalVisible = true;
    }
  }

  hideEditModal1(params: any) {
    this.addData = {};
    this.editModalVisible = false;
    this.loadPriceSettings();
  }
}
